import { ConversationBucket } from "@/lib/api/training-simulator-content";
import { cn } from "@/lib/utils";

export const formatBucket = (bucket: ConversationBucket) =>
  bucket
    .split("_")
    .map((part) => part[0].toUpperCase() + part.slice(1))
    .join(" ");

const bucketStyles: Record<ConversationBucket, string> = {
  new: "bg-blue-50 text-blue-700 ring-blue-200",
  needs_response: "bg-amber-50 text-amber-700 ring-amber-200",
  online: "bg-green-50 text-green-700 ring-green-200",
  low_engagement: "bg-gray-100 text-gray-600 ring-gray-200",
};

export function BucketBadge({
  bucket,
  className,
}: {
  bucket: ConversationBucket;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset",
        bucketStyles[bucket],
        className,
      )}
    >
      {formatBucket(bucket)}
    </span>
  );
}
